var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var _a;
var _b, _c, _d, _e, _f;
import { TravelError } from "@travel/shared/utils";
import { ON_SDK_READY, REFRESH_SDK, } from "./types";
var ALLOW_DARK_MODE = ((_b = document.currentScript) === null || _b === void 0 ? void 0 : _b.getAttribute("data-dark-mode")) == "true";
var SRC = ((_c = document.currentScript) === null || _c === void 0 ? void 0 : _c.getAttribute("src")) || "";
var PARAMS = ((_e = (_d = SRC.split("?")) === null || _d === void 0 ? void 0 : _d[1]) === null || _e === void 0 ? void 0 : _e.split("&").reduce(function (acc, part) {
    var _a = __read(part.split("="), 2), key = _a[0], value = _a[1];
    acc[key] = value;
    return acc;
}, {})) || {};
var PARTNER_ID = ((_f = document.currentScript) === null || _f === void 0 ? void 0 : _f.getAttribute("data-partner-id")) ||
    PARAMS["partner-id"] ||
    process.env.NEXT_PUBLIC_PARTNER_ID;
var __IS_DEV_MODE__ = PARAMS["dev-mode"];
var TravelSDK = (window.TravelSDK = window.TravelSDK || (_a = {
        init: init
    },
    _a[REFRESH_SDK] = function () { },
    _a[ON_SDK_READY] = null,
    _a));
if (PARTNER_ID) {
    init(PARTNER_ID, {
        darkMode: ALLOW_DARK_MODE,
    });
}
function init(id, options) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!TravelSDK[ON_SDK_READY]) return [3 /*break*/, 2];
                    return [4 /*yield*/, TravelSDK[ON_SDK_READY]];
                case 1:
                    _a.sent();
                    TravelSDK[REFRESH_SDK]();
                    return [3 /*break*/, 3];
                case 2:
                    TravelSDK[ON_SDK_READY] = initSDK(id);
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    });
}
function initSDK(partnerID_1) {
    return __awaiter(this, arguments, void 0, function (partnerID, _a) {
        var _b, config, initSDKRoot, error_1, travelError;
        var _c = _a === void 0 ? {} : _a, darkMode = _c.darkMode;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    console.log({ partnerID: partnerID });
                    _d.label = 1;
                case 1:
                    _d.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, Promise.all([
                            fetchConfig(partnerID),
                            import("./init"),
                        ])];
                case 2:
                    _b = __read.apply(void 0, [_d.sent(), 2]), config = _b[0], initSDKRoot = _b[1].initSDKRoot;
                    addDocumentThemePaletteCSS(config.theme.colors);
                    //addCSSVariables(config.theme.css);
                    initSDKRoot(__assign(__assign({}, config), { partnerID: partnerID, app: "sdk" }));
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _d.sent();
                    travelError = new TravelError({
                        code: "sdk:init",
                        message: "TravelSDK.Init.Error.LoadFailed",
                        partnerID: partnerID,
                        url: typeof window !== "undefined" ? window.location.href : "",
                    });
                    console.groupCollapsed(travelError.message);
                    console.error(error_1);
                    console.groupEnd();
                    throw travelError;
                case 4: return [2 /*return*/];
            }
        });
    });
}
function addCSSVariables(theme) {
    for (var prop in theme) {
        //@TODO: Deprecate one
        document.documentElement.style.setProperty("--travel-".concat(prop), theme[prop]);
        document.documentElement.style.setProperty("--travel-theme-".concat(prop), theme[prop]);
    }
}
function fetchConfig(partnerID) {
    return __awaiter(this, void 0, void 0, function () {
        var result, config;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, fetch("https://travel-partner-one.vercel.app/api/config/".concat(partnerID))];
                case 1:
                    result = _a.sent();
                    return [4 /*yield*/, result.json()];
                case 2:
                    config = _a.sent();
                    return [2 /*return*/, config];
            }
        });
    });
}
function addDocumentThemePaletteCSS(colors) {
    var e_1, _a;
    if (colors === void 0) { colors = []; }
    if (!(colors === null || colors === void 0 ? void 0 : colors.length))
        return;
    try {
        for (var colors_1 = __values(colors), colors_1_1 = colors_1.next(); !colors_1_1.done; colors_1_1 = colors_1.next()) {
            var _b = colors_1_1.value, type = _b.type, color = _b.color, variant = _b.variant, text = _b.text, darkColor = _b.darkColor, darkVariant = _b.darkVariant, darkText = _b.darkText;
            document.documentElement.style.setProperty("--travel-".concat(type, "-color"), //@TODO Deprecate
            color);
            document.documentElement.style.setProperty("--travel-theme-".concat(type, "-color"), color);
            document.documentElement.style.setProperty("--travel-theme-light-".concat(type, "-color"), color);
            if (text) {
                document.documentElement.style.setProperty("--travel-theme-light-".concat(type, "-text-color"), text);
                document.documentElement.style.setProperty("--travel-theme-".concat(type, "-text-color"), text);
            }
            if (variant) {
                document.documentElement.style.setProperty("--travel-".concat(type, "-variant-color"), //@TODO Deprecate
                variant);
                document.documentElement.style.setProperty("--travel-theme-".concat(type, "-variant-color"), variant);
                document.documentElement.style.setProperty("--travel-theme-light-".concat(type, "-variant-color"), variant);
            }
            if (darkColor) {
                document.documentElement.style.setProperty("--travel-theme-dark-".concat(type, "-color"), darkColor);
                if (darkVariant) {
                    document.documentElement.style.setProperty("--travel-theme-dark-".concat(type, "-variant-color"), darkVariant);
                }
            }
            if (darkText) {
                document.documentElement.style.setProperty("--travel-theme-dark-".concat(type, "-text-color"), darkText);
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (colors_1_1 && !colors_1_1.done && (_a = colors_1.return)) _a.call(colors_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
}
